<template>
  <a href="#" @click.prevent="goTo">
    <font-awesome-icon icon="angle-left" />
    &nbsp;
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: ["to"],
  methods: {
    goTo() {
      if (this.to) {
        this.$router.push(this.to);
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="less" scoped>
a {
  color: #34404d;
  display: inline-block;
  margin-bottom: 1.5em;
  margin-top: 1.5em;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
}
</style>